import { get } from 'lodash'
import { required, email, phone } from 'utils/validation'
import { CONFIGURATION_KEYS } from '../../constants/enums'

export default function(values = {}, props) {
  const isOrganizationContact = get(props, 'isOrganizationContact')

  const cfg = get(props, 'configuration')

  const orgId = get(props, 'activeOrganizationId')

  const isConfigTrue = configKey => get(cfg, `valuesByOrganizationId[${orgId}][${configKey}].booleanValue`)

  return {
    firstName: required(get(values, 'firstName')),
    lastName: required(get(values, 'lastName')),
    email: required(get(values, 'email')) || email(get(values, 'email')),
    phone: isConfigTrue(CONFIGURATION_KEYS.awardStaffRegistrationPhone.id) && required(get(values, 'phone')) || phone(get(values, 'phone')),
    phoneType: { value: required(get(values, 'phoneType.value')) },
    birthDate: !isOrganizationContact && required(get(values, 'birthDate')),
    address: {
      line1: isConfigTrue(CONFIGURATION_KEYS.awardStaffRegistrationAddressLine1.id) && required(get(values, 'address.line1')),
      city: isConfigTrue(CONFIGURATION_KEYS.awardStaffRegistrationAddressCity.id) && required(get(values, 'address.city')),
      zipCode: isConfigTrue(CONFIGURATION_KEYS.awardStaffRegistrationAddressZipCode.id) && required(get(values, 'address.zipCode')),
      country: { id: isConfigTrue(CONFIGURATION_KEYS.awardStaffRegistrationAddressCountry.id) && required(get(values, 'address.country.id')) }
    }
  }
}
